







import { Component, Vue } from "vue-property-decorator";
import Api from "@/api";
import HelloWorld from "@/components/HelloWorld.vue";
import { AxiosResponse } from "axios";

Component.registerHooks(["beforeRouteEnter"]);

@Component({
  components: {
    HelloWorld
  }
})
export default class Home extends Vue {
  private beforeRouteEnter(to: any, from: any, next: any): void {
    next((vm: this) => {
      vm.getUsers(() => {
        //
      });
    });
  }

  private getUsers(successCallback?: any): void {
    const endpoint: string = this.$partnerEndpoint("users");

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        console.log(response.status);
        this.$router.push({
          name: "UsersOverview"
        });
        if (typeof successCallback === "function") {
          successCallback();
        }
      })
      .catch((response: any) => {
        console.log(response.status);
      });
  }
}
